export const SURVEY_SERIES_LIST = 'SURVEY_SERIES_LIST';
export const SURVEY_SERIES_LIST_SUCCESS = 'SURVEY_SERIES_LIST_SUCCESS';
export const SURVEY_SERIES_LIST_ERROR = 'SURVEY_SERIES_LIST_ERROR';

export const SURVEY_SERIES_UPDATE_DATA = 'SURVEY_SERIES_UPDATE_DATA';